import { guid } from '../../../../shared/utils/guid';

// Action types
export const ADD_CARD = 'ADD_CARD';
export const ADD_CARD_IN_COLUMN = 'ADD_CARD_IN_COLUMN';
export const CHANGE_COLUMN = 'CHANGE_COLUMN';
export const CLEAR_STATE = 'CLEAR_STATE';
export const CLOSE_CARD_MODAL = 'CLOSE_CARD_MODAL';
export const CLOSE_CARD_MODAL_ACTION = 'CLOSE_CARD_MODAL_ACTION';
export const CREATE_COLUMN = 'CREATE_COLUMN';
export const DUPLICATE_CARD = 'DUPLICATE_CARD';
export const MARK_AS_SYNCED = 'MARK_AS_SYNCED';
export const MARK_CARD_WITH_ERROR = 'MARK_CARD_WITH_ERROR';
export const MOVE_CARD = 'MOVE_CARD';
export const OPEN_CARD_MODAL = 'OPEN_CARD_MODAL';
export const RECEIVE_CARDS = 'RECEIVE_CARDS';
export const REMOVE_CARD = 'REMOVE_CARD';
export const REMOVE_CARD_FROM_COLUMN = 'REMOVE_CARD_FROM_COLUMN';
export const REPLACE_CARD = 'REPLACE_CARD';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_LOGGED_USER = 'SET_LOGGED_USER';
export const SET_SEARCH = 'SET_SEARCH';
export const SHOW_UPDATE_NOTIFICATION = 'SHOW_UPDATE_NOTIFICATION';
export const TOGGLE_DISMISS = 'TOGGLE_DISMISS';
export const UPDATE_CARD = 'UPDATE_CARD';
export const UPDATE_CARD_MODAL = 'UPDATE_CARD_MODAL';
export const UPDATE_CARD_MODAL_CUSTOM_DATA = 'UPDATE_CARD_MODAL_CUSTOM_DATA';
export const UPDATE_CUSTOM_DATA_INPUT = 'UPDATE_CUSTOM_DATA_INPUT';
export const UPDATE_IS_DRAGGING = 'UPDATE_IS_DRAGGING';

// Action creators
export function addCard(card) {
    return {
        type: ADD_CARD,
        card: { ...card, id: guid(), temporaryId: true },
    };
}

export function addCardInColumn(card) {
    return {
        type: ADD_CARD,
        card,
    };
}

export function updateCard(card) {
    return {
        type: UPDATE_CARD,
        card,
    };
}

export function removeCard(card) {
    return {
        type: REMOVE_CARD,
        card,
    };
}

export function removeCardFromColumn(card) {
    return {
        type: REMOVE_CARD_FROM_COLUMN,
        card,
    };
}

export const duplicateCard = card => ({
    type: DUPLICATE_CARD,
    card,
});

export function moveCard(card, column, index) {
    return {
        type: MOVE_CARD,
        card,
        column,
        index,
    };
}

export function createColumn(columnType) {
    return {
        type: CREATE_COLUMN,
        columnType,
    };
}

export function changeColumn(card, newStatus) {
    return {
        type: CHANGE_COLUMN,
        card,
        status: newStatus,
    };
}

export function receiveCards(cards) {
    return {
        type: RECEIVE_CARDS,
        cards,
    };
}

export function replaceCard(oldCard, newCard) {
    return {
        type: REPLACE_CARD,
        oldCard,
        newCard,
    };
}

export function markAsSynced(card) {
    return {
        type: MARK_AS_SYNCED,
        card,
    };
}

export function clearCards(initialEmptyColumns) {
    return {
        type: CLEAR_STATE,
        emptyColumns: initialEmptyColumns,
    };
}

export function setFilters(filters) {
    return {
        type: SET_FILTERS,
        filters,
    };
}

export function setSearch(search) {
    return {
        type: SET_SEARCH,
        search,
    };
}

export const showOrHideUpdateNotification = notificationStatus => ({
    type: SHOW_UPDATE_NOTIFICATION,
    payload: notificationStatus,
});

export const setLoggedUser = user => ({
    type: SET_LOGGED_USER,
    user,
});

export const markCardWithError = (cardId, message = null, eventId) => ({
    type: MARK_CARD_WITH_ERROR,
    cardId,
    message,
    eventId,
});

export const updateIsDragging = isDragging => ({
    type: UPDATE_IS_DRAGGING,
    isDragging,
});
